import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import moment from 'moment'
import PEASummary from './PEASummary'
import PEAStaffFeedback from './PEAStaffFeedback'
import PEAClientFeedback from './PEAClientFeedback'
import PEAThemes from './Themes'
import Actions from './Actions'
import PatientSummary from './PatientSummary'
import GenerateReport from './Report/GenerateReport'
import { EventMetaContext } from '../SingleEvent'
import { TenantSettingsContext } from '../../../../App'
import UpgradeRequired from '../../../../components/Upgrade/UpgradeGate'
import UpgradeLock from '../../../../assets/icons/UpgradeLock'

const PEA = ({ embedded = false }) => {
  const { tenantInfo } = useContext(TenantSettingsContext)
  const { eventMeta } = useContext(EventMetaContext)
  const [accordionOpen, setAccordionOpen] = useState(false)

  useEffect(() => {
    if (
      tenantInfo?.subscriptionTier > 1 &&
      moment().subtract(4, 'hours').isAfter(eventMeta.endDate)
    ) {
      setAccordionOpen(true)
    }
  }, [tenantInfo])

  const [pcrData, setPCRData] = useState([])

  const content =
    tenantInfo?.subscriptionTier < 2 ? (
      <UpgradeRequired inline />
    ) : (
      <Stack gap={1}>
        <PEASummary />
        <PEAStaffFeedback />
        <PEAClientFeedback />
        <Stack gap={2} divider={<Divider />} marginTop={2}>
          <PEAThemes />
          <Actions />
          <PatientSummary data={pcrData} setData={setPCRData} />
          <GenerateReport />
        </Stack>
      </Stack>
    )

  if (embedded) return content

  return (
    <Box
      border={moment().isAfter(eventMeta.endDate) ? 'solid 2px' : 'solid 1px'}
      borderColor={moment().isAfter(eventMeta.endDate) ? '#ab0000' : '#39485e'}
      borderRadius={1}
    >
      <Accordion disableGutters expanded={accordionOpen}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ display: 'flex' }}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <Stack
            direction="row"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="title3">Post Event Analysis</Typography>
            {tenantInfo?.subscriptionTier < 2 ? <UpgradeLock /> : ''}
          </Stack>
        </AccordionSummary>
        <AccordionDetails>{content}</AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default React.memo(PEA)
